<div
  class="mx-xs-3 user-access-expired-default-main d-flex flex-column justify-content-center align-items-center"
>
  <div class="text-container">
    <div class="icon-container ml-auto mr-auto mb-3">
      <img src="assets/svg/ico-lock-circle.svg" class="user-icon" />
    </div>
    <div class="text-center mb-4">
      <h2 class="heading">{{ 'RECORD_NOT_FOUND' | translate }}</h2>
      <p class="empty-box">
        {{ 'REQUEST_TO_GET_LOCK_FAILED' | translate }}
      </p>
    </div>
  </div>
</div>
